export const mockDealer = {
  id: "d1",
  dealerCode: "ART001",
  dealerName: "Demo Bayi",
  password: "123456",
  isActive: true,
  hasAccounting: true,
  hasEArchive: true,
  hasEInvoice: false,
};

export const mockDashboardSummary = {
  cashSales: 15750.50,
  posSales: 23420.75,
  ibanSales: 8900.00,
  currentSales: 12300.25,
  totalSales: 60371.50,
};

export const mockShelves = [
  { id: "sh1", name: "A-01 (Giriş Vitrin)" },
  { id: "sh2", name: "A-02 (Telefon Reyonu)" },
  { id: "sh3", name: "B-01 (Bilgisayar Reyonu)" },
  { id: "sh4", name: "B-02 (Aksesuar Standı)" },
  { id: "sh5", name: "C-01 (Depo Rafı)" },
  { id: "sh6", name: "C-02 (Konsol Bölümü)" },
];

export const mockProducts = [
  {
    id: "p1",
    productCode: "URUN-001",
    barcode: "8691234567890",
    name: "iPhone 15 128GB Siyah",
    brand: "Apple",
    model: "iPhone 15",
    categoryId: "c1",
    supplierId: "s1",
    shelfLocation: "A-02 (Telefon Reyonu)",
    purchasePrice: 42000.00,
    salePrice: 48999.00,
    stock: 3,
    imageUrl: "https://readdy.ai/api/search-image?query=iPhone%2015%20black%20smartphone%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-iphone15&orientation=squarish",
  },
  {
    id: "p2",
    productCode: "URUN-002",
    barcode: "8691234567891",
    name: "Samsung Galaxy S24 Ultra 256GB",
    brand: "Samsung",
    model: "Galaxy S24 Ultra",
    categoryId: "c1",
    supplierId: "s2",
    shelfLocation: "A-02 (Telefon Reyonu)",
    purchasePrice: 38000.00,
    salePrice: 44999.00,
    stock: 7,
    imageUrl: "https://readdy.ai/api/search-image?query=Samsung%20Galaxy%20S24%20Ultra%20smartphone%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-s24u&orientation=squarish",
  },
  {
    id: "p3",
    productCode: "URUN-003",
    barcode: "8691234567892",
    name: "MacBook Air M3 15\" 8GB 256GB",
    brand: "Apple",
    model: "MacBook Air M3",
    categoryId: "c2",
    supplierId: "s1",
    shelfLocation: "B-01 (Bilgisayar Reyonu)",
    purchasePrice: 38500.00,
    salePrice: 42999.00,
    stock: 0,
    imageUrl: "https://readdy.ai/api/search-image?query=MacBook%20Air%20M3%20laptop%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-mba&orientation=squarish",
  },
  {
    id: "p4",
    productCode: "URUN-004",
    barcode: "8691234567893",
    name: "AirPods Pro 2. Nesil USB-C",
    brand: "Apple",
    model: "AirPods Pro 2",
    categoryId: "c4",
    supplierId: "s1",
    shelfLocation: "B-02 (Aksesuar Standı)",
    purchasePrice: 5200.00,
    salePrice: 6499.00,
    stock: 12,
    imageUrl: "https://readdy.ai/api/search-image?query=AirPods%20Pro%202%20earbuds%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-airpods&orientation=squarish",
  },
  {
    id: "p5",
    productCode: "URUN-005",
    barcode: "8691234567894",
    name: "Samsung 65\" 4K QLED Smart TV",
    brand: "Samsung",
    model: "QE65Q80C",
    categoryId: "c5",
    supplierId: "s2",
    shelfLocation: "C-01 (Depo Rafı)",
    purchasePrice: 28500.00,
    salePrice: 32999.00,
    stock: 5,
    imageUrl: "",
  },
  {
    id: "p6",
    productCode: "URUN-006",
    barcode: "8691234567895",
    name: "PlayStation 5 Digital Edition",
    brand: "Sony",
    model: "PS5 Digital",
    categoryId: "c6",
    supplierId: "s3",
    shelfLocation: "C-02 (Konsol Bölümü)",
    purchasePrice: 13200.00,
    salePrice: 15499.00,
    stock: 0,
    imageUrl: "https://readdy.ai/api/search-image?query=PlayStation%205%20Digital%20game%20console%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-ps5&orientation=squarish",
  },
  {
    id: "p7",
    productCode: "URUN-007",
    barcode: "8691234567896",
    name: "iPad Air 11\" M2 128GB WiFi",
    brand: "Apple",
    model: "iPad Air M2",
    categoryId: "c3",
    supplierId: "s1",
    shelfLocation: "B-01 (Bilgisayar Reyonu)",
    purchasePrice: 21800.00,
    salePrice: 24999.00,
    stock: 1,
    imageUrl: "https://readdy.ai/api/search-image?query=iPad%20Air%2011%20inch%20M2%20tablet%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-ipad&orientation=squarish",
  },
  {
    id: "p8",
    productCode: "URUN-008",
    barcode: "8691234567897",
    name: "Apple Watch Series 9 45mm",
    brand: "Apple",
    model: "Watch Series 9",
    categoryId: "c4",
    supplierId: "s1",
    shelfLocation: "B-02 (Aksesuar Standı)",
    purchasePrice: 11800.00,
    salePrice: 13999.00,
    stock: 4,
    imageUrl: "",
  },
  {
    id: "p9",
    productCode: "URUN-009",
    barcode: "8691234567898",
    name: "Xiaomi 14T Pro 512GB",
    brand: "Xiaomi",
    model: "14T Pro",
    categoryId: "c1",
    supplierId: "s2",
    shelfLocation: "A-02 (Telefon Reyonu)",
    purchasePrice: 21500.00,
    salePrice: 24999.00,
    stock: 6,
    imageUrl: "https://readdy.ai/api/search-image?query=Xiaomi%2014T%20Pro%20smartphone%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-xiaomi&orientation=squarish",
  },
  {
    id: "p10",
    productCode: "URUN-010",
    barcode: "8691234567899",
    name: "JBL Charge 5 Bluetooth Hoparlör",
    brand: "JBL",
    model: "Charge 5",
    categoryId: "c4",
    supplierId: "s3",
    shelfLocation: "B-02 (Aksesuar Standı)",
    purchasePrice: 2450.00,
    salePrice: 3199.00,
    stock: 15,
    imageUrl: "https://readdy.ai/api/search-image?query=JBL%20Charge%205%20bluetooth%20speaker%20isolated%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20minimal%20lighting%2C%20sharp%20detail%2C%20no%20shadows%2C%20studio%20setup&width=400&height=400&seq=product-jbl&orientation=squarish",
  },
];

export const mockIbanList = [
  { id: "i1", bankName: "Ziraat Bankası", ibanNumber: "TR12 0001 0012 3456 7890 1234 56" },
  { id: "i2", bankName: "Garanti BBVA", ibanNumber: "TR98 0006 2001 2345 6789 0123 45" },
  { id: "i3", bankName: "İş Bankası", ibanNumber: "TR76 0004 6001 2345 6789 0123 45" },
];

export const mockBankAccounts = [
  { id: "ba1", bankName: "Ziraat Bankası", branchCode: "0001", branchName: "Merkez Şube", ibanNumber: "TR12 0001 0012 3456 7890 1234 56", accountHolder: "ART POS Ticaret A.Ş.", accountNumber: "01234567890123456", currency: "USD", isActive: true },
  { id: "ba2", bankName: "Garanti BBVA", branchCode: "0006", branchName: "Levent Şube", ibanNumber: "TR98 0006 2001 2345 6789 0123 45", accountHolder: "ART POS Ticaret A.Ş.", accountNumber: "200123456789012345", currency: "USD", isActive: true },
  { id: "ba3", bankName: "İş Bankası", branchCode: "0004", branchName: "Maslak Şube", ibanNumber: "TR76 0004 6001 2345 6789 0123 45", accountHolder: "ART POS Ticaret A.Ş.", accountNumber: "600123456789012345", currency: "USD", isActive: true },
  { id: "ba4", bankName: "Yapı Kredi", branchCode: "0002", branchName: "Beşiktaş Şube", ibanNumber: "TR55 0002 5001 2345 6789 0123 45", accountHolder: "ART POS Ticaret A.Ş.", accountNumber: "500123456789012345", currency: "USD", isActive: false },
  { id: "ba5", bankName: "Akbank", branchCode: "0003", branchName: "Şişli Şube", ibanNumber: "TR23 0003 3001 2345 6789 0123 45", accountHolder: "ART POS Ticaret A.Ş.", accountNumber: "300123456789012345", currency: "USD", isActive: true },
];

export const mockCurrentDealers = [
  { id: "cd1", name: "TeknoMarket Ltd. Şti.", phone: "0212 555 10 01", address: "İstanbul / Şişli", balance: 15000.00 },
  { id: "cd2", name: "DijitalDünya Ticaret", phone: "0216 444 20 02", address: "İstanbul / Kadıköy", balance: 8750.50 },
  { id: "cd3", name: "BilişimCenter A.Ş.", phone: "0232 333 30 03", address: "İzmir / Bornova", balance: 22000.00 },
];

export const mockCategories = [
  { id: "c1", name: "Cep Telefonu" },
  { id: "c2", name: "Bilgisayar" },
  { id: "c3", name: "Tablet" },
  { id: "c4", name: "Aksesuar" },
  { id: "c5", name: "Televizyon" },
  { id: "c6", name: "Oyun Konsolu" },
];

export const mockSuppliers = [
  { id: "s1", name: "TechDist Toptan", phone: "0212 777 10 01", email: "info@techdist.com" },
  { id: "s2", name: "MobilTedarik A.Ş.", phone: "0216 888 20 02", email: "satis@mobiltedarik.com" },
  { id: "s3", name: "DijitalDağıtım Ltd.", phone: "0232 999 30 03", email: "info@dijitaldagitim.com" },
];

export const mockRecentSales = [
  { id: "s1", productName: "iPhone 15 128GB", quantity: 1, amount: 48999.00, paymentMethod: "nakit", date: "2026-07-14T10:30:00" },
  { id: "s2", productName: "AirPods Pro 2", quantity: 2, amount: 12998.00, paymentMethod: "pos", date: "2026-07-14T11:15:00" },
  { id: "s3", productName: "Samsung Galaxy S24 Ultra", quantity: 1, amount: 44999.00, paymentMethod: "iban", date: "2026-07-14T13:00:00" },
  { id: "s4", productName: "MacBook Air M3", quantity: 1, amount: 42999.00, paymentMethod: "cari", date: "2026-07-14T14:45:00" },
  { id: "s5", productName: "PS5 Digital Edition", quantity: 3, amount: 46497.00, paymentMethod: "nakit", date: "2026-07-14T16:20:00" },
];

// Detailed sales history for reports
export const mockSalesHistory = [
  { id: "sh1", productName: "iPhone 15 128GB", brand: "Apple", quantity: 1, amount: 48999.00, cost: 42000.00, profit: 6999.00, paymentMethod: "nakit", date: "2026-07-14T10:30:00", dealerName: "TeknoMarket Ltd. Şti." },
  { id: "sh2", productName: "AirPods Pro 2", brand: "Apple", quantity: 2, amount: 12998.00, cost: 10400.00, profit: 2598.00, paymentMethod: "pos", date: "2026-07-14T11:15:00", dealerName: "-" },
  { id: "sh3", productName: "Samsung Galaxy S24 Ultra", brand: "Samsung", quantity: 1, amount: 44999.00, cost: 38000.00, profit: 6999.00, paymentMethod: "iban", date: "2026-07-14T13:00:00", dealerName: "-" },
  { id: "sh4", productName: "MacBook Air M3", brand: "Apple", quantity: 1, amount: 42999.00, cost: 38500.00, profit: 4499.00, paymentMethod: "cari", date: "2026-07-14T14:45:00", dealerName: "DijitalDünya Ticaret" },
  { id: "sh5", productName: "PS5 Digital Edition", brand: "Sony", quantity: 3, amount: 46497.00, cost: 39600.00, profit: 6897.00, paymentMethod: "nakit", date: "2026-07-14T16:20:00", dealerName: "-" },
  { id: "sh6", productName: "iPad Air M2", brand: "Apple", quantity: 1, amount: 24999.00, cost: 21800.00, profit: 3199.00, paymentMethod: "pos", date: "2026-07-13T09:45:00", dealerName: "BilişimCenter A.Ş." },
  { id: "sh7", productName: "Xiaomi 14T Pro", brand: "Xiaomi", quantity: 2, amount: 49998.00, cost: 43000.00, profit: 6998.00, paymentMethod: "nakit", date: "2026-07-13T14:30:00", dealerName: "-" },
  { id: "sh8", productName: "JBL Charge 5", brand: "JBL", quantity: 5, amount: 15995.00, cost: 12250.00, profit: 3745.00, paymentMethod: "pos", date: "2026-07-13T17:00:00", dealerName: "-" },
  { id: "sh9", productName: "Samsung 65\" QLED TV", brand: "Samsung", quantity: 1, amount: 32999.00, cost: 28500.00, profit: 4499.00, paymentMethod: "iban", date: "2026-07-12T11:00:00", dealerName: "-" },
  { id: "sh10", productName: "iPhone 15 128GB", brand: "Apple", quantity: 2, amount: 97998.00, cost: 84000.00, profit: 13998.00, paymentMethod: "cari", date: "2026-07-12T15:20:00", dealerName: "TeknoMarket Ltd. Şti." },
  { id: "sh11", productName: "MacBook Air M3", brand: "Apple", quantity: 1, amount: 42999.00, cost: 38500.00, profit: 4499.00, paymentMethod: "nakit", date: "2026-07-11T10:15:00", dealerName: "-" },
  { id: "sh12", productName: "Apple Watch Series 9", brand: "Apple", quantity: 3, amount: 41997.00, cost: 35400.00, profit: 6597.00, paymentMethod: "pos", date: "2026-07-11T13:45:00", dealerName: "-" },
  { id: "sh13", productName: "PS5 Digital Edition", brand: "Sony", quantity: 1, amount: 15499.00, cost: 13200.00, profit: 2299.00, paymentMethod: "nakit", date: "2026-07-10T12:00:00", dealerName: "-" },
  { id: "sh14", productName: "AirPods Pro 2", brand: "Apple", quantity: 4, amount: 25996.00, cost: 20800.00, profit: 5196.00, paymentMethod: "iban", date: "2026-07-09T16:30:00", dealerName: "-" },
  { id: "sh15", productName: "Samsung Galaxy S24 Ultra", brand: "Samsung", quantity: 1, amount: 44999.00, cost: 38000.00, profit: 6999.00, paymentMethod: "cari", date: "2026-07-08T09:00:00", dealerName: "BilişimCenter A.Ş." },
  { id: "sh16", productName: "iPad Air M2", brand: "Apple", quantity: 2, amount: 49998.00, cost: 43600.00, profit: 6398.00, paymentMethod: "nakit", date: "2026-07-07T11:30:00", dealerName: "-" },
  { id: "sh17", productName: "JBL Charge 5", brand: "JBL", quantity: 3, amount: 9597.00, cost: 7350.00, profit: 2247.00, paymentMethod: "pos", date: "2026-07-06T14:00:00", dealerName: "-" },
  { id: "sh18", productName: "Xiaomi 14T Pro", brand: "Xiaomi", quantity: 1, amount: 24999.00, cost: 21500.00, profit: 3499.00, paymentMethod: "nakit", date: "2026-07-05T10:45:00", dealerName: "DijitalDünya Ticaret" },
  { id: "sh19", productName: "Samsung 65\" QLED TV", brand: "Samsung", quantity: 2, amount: 65998.00, cost: 57000.00, profit: 8998.00, paymentMethod: "pos", date: "2026-07-04T15:00:00", dealerName: "-" },
  { id: "sh20", productName: "Apple Watch Series 9", brand: "Apple", quantity: 2, amount: 27998.00, cost: 23600.00, profit: 4398.00, paymentMethod: "iban", date: "2026-07-03T12:30:00", dealerName: "-" },
];

// Accounting entries
export const mockAccountingEntries = [
  { id: "a1", date: "2026-07-14", type: "gelir", category: "Satış", description: "Günlük satış gelirleri - Nakit", amount: 63496.00 },
  { id: "a2", date: "2026-07-14", type: "gelir", category: "Satış", description: "Günlük satış gelirleri - POS", amount: 23420.75 },
  { id: "a3", date: "2026-07-14", type: "gelir", category: "Satış", description: "Günlük satış gelirleri - IBAN", amount: 8900.00 },
  { id: "a4", date: "2026-07-14", type: "gelir", category: "Satış", description: "Günlük satış gelirleri - Cari", amount: 12300.25 },
  { id: "a5", date: "2026-07-14", type: "gider", category: "Kira", description: "Temmuz ayı dükkan kirası", amount: 15000.00 },
  { id: "a6", date: "2026-07-14", type: "gider", category: "Personel", description: "Personel maaş ödemesi", amount: 42500.00 },
  { id: "a7", date: "2026-07-13", type: "gider", category: "Tedarikçi", description: "TechDist Toptan - Ürün alımı", amount: 85000.00 },
  { id: "a8", date: "2026-07-13", type: "gelir", category: "Satış", description: "Günlük satış gelirleri", amount: 90992.00 },
  { id: "a9", date: "2026-07-12", type: "gider", category: "Fatura", description: "Elektrik faturası", amount: 3250.00 },
  { id: "a10", date: "2026-07-12", type: "gider", category: "Fatura", description: "İnternet faturası", amount: 850.00 },
  { id: "a11", date: "2026-07-11", type: "gelir", category: "Satış", description: "Günlük satış gelirleri", amount: 84996.00 },
  { id: "a12", date: "2026-07-11", type: "gider", category: "Tedarikçi", description: "MobilTedarik A.Ş. - Ürün alımı", amount: 64500.00 },
  { id: "a13", date: "2026-07-10", type: "gelir", category: "Satış", description: "Günlük satış gelirleri", amount: 15499.00 },
  { id: "a14", date: "2026-07-09", type: "gelir", category: "Satış", description: "Günlük satış gelirleri", amount: 25996.00 },
  { id: "a15", date: "2026-07-08", type: "gelir", category: "Satış", description: "Günlük satış gelirleri", amount: 44999.00 },
];

// Support tickets
export const mockSupportTickets = [
  { id: "st1", subject: "Ürün barkodu okunmuyor", message: "URUN-005 kodlu Samsung TV'nin barkodunu okutamıyorum. Manuel giriş yapıyorum ama satış ekranında hata alıyorum.", status: "open", date: "2026-07-14T09:30:00", replies: [{ from: "admin", message: "Merhaba, barkod okuyucu ayarlarınızı kontrol edelim. Hangi barkod okuyucu modelini kullanıyorsunuz?", date: "2026-07-14T10:00:00" }] },
  { id: "st2", subject: "Raporlama hatası", message: "Aylık satış raporu almak istediğimde Temmuz ayı verileri eksik görünüyor. 8-12 Temmuz arası satışlar raporda yok.", status: "open", date: "2026-07-13T14:20:00", replies: [] },
  { id: "st3", subject: "Cari bayi bakiyesi güncellenmiyor", message: "BilişimCenter A.Ş. için yaptığım tahsilat sonrası cari bakiye güncellenmedi. Tahsilatı sisteme işledim fakat bakiye aynı kaldı.", status: "closed", date: "2026-07-10T11:00:00", replies: [{ from: "admin", message: "Sorun çözüldü. Cache temizliği yapıldı, bakiye şimdi doğru görünüyor olmalı.", date: "2026-07-10T11:45:00" }] },
  { id: "st4", subject: "e-Fatura modülü aktif etme", message: "e-Fatura modülünü kullanmak istiyorum. Gerekli entegrasyon için ne yapmam gerekiyor?", status: "open", date: "2026-07-12T16:45:00", replies: [{ from: "admin", message: "e-Fatura modülü için öncelikle Gelir İdaresi Başkanlığı'na başvuru yapmanız gerekiyor. Size gerekli belgeleri ileteceğiz.", date: "2026-07-12T17:30:00" }] },
];

// Admin data
export const mockAdminUsers = [
  { id: "au1", username: "admin", password: "admin123", role: "super_admin", createdAt: "2026-01-01T00:00:00" },
  { id: "au2", username: "satis.yonetici", password: "satis123", role: "admin", createdAt: "2026-03-15T00:00:00" },
];

export const mockAllDealers = [
  { id: "d1", dealerCode: "ART001", dealerName: "Demo Bayi", isActive: true, hasAccounting: true, hasEArchive: true, hasEInvoice: false, createdAt: "2026-01-15T10:00:00" },
  { id: "d2", dealerCode: "ART002", dealerName: "İstanbul Şube", isActive: true, hasAccounting: true, hasEArchive: true, hasEInvoice: true, createdAt: "2026-02-20T14:30:00" },
  { id: "d3", dealerCode: "ART003", dealerName: "Ankara Şube", isActive: true, hasAccounting: false, hasEArchive: true, hasEInvoice: false, createdAt: "2026-03-10T09:15:00" },
  { id: "d4", dealerCode: "ART004", dealerName: "İzmir Şube", isActive: false, hasAccounting: false, hasEArchive: false, hasEInvoice: false, createdAt: "2026-04-05T11:00:00" },
  { id: "d5", dealerCode: "ART005", dealerName: "Bursa Şube", isActive: true, hasAccounting: true, hasEArchive: true, hasEInvoice: true, createdAt: "2026-05-18T16:45:00" },
];

export const mockDealerUsers = [
  { id: "du1", dealerId: "d1", username: "demo.satis", fullName: "Ahmet Yılmaz", role: "Satış Temsilcisi", isActive: true },
  { id: "du2", dealerId: "d1", username: "demo.muhasebe", fullName: "Ayşe Demir", role: "Muhasebe", isActive: true },
  { id: "du3", dealerId: "d2", username: "ist.satis1", fullName: "Mehmet Kaya", role: "Satış Temsilcisi", isActive: true },
  { id: "du4", dealerId: "d2", username: "ist.satis2", fullName: "Zeynep Çelik", role: "Satış Temsilcisi", isActive: false },
  { id: "du5", dealerId: "d3", username: "ank.satis", fullName: "Ali Öztürk", role: "Satış Müdürü", isActive: true },
];

// Dealer logs
export const mockDealerLogs = [
  { id: "dl1", dealerId: "d1", dealerName: "Demo Bayi", action: "Giriş", detail: "Sisteme giriş yapıldı", ip: "192.168.1.100", date: "2026-07-14T08:30:00" },
  { id: "dl2", dealerId: "d1", dealerName: "Demo Bayi", action: "Satış", detail: "iPhone 15 128GB - Nakit 48.999 TL", ip: "192.168.1.100", date: "2026-07-14T10:30:00" },
  { id: "dl3", dealerId: "d1", dealerName: "Demo Bayi", action: "Satış", detail: "AirPods Pro 2 - POS 12.998 TL (2 adet)", ip: "192.168.1.100", date: "2026-07-14T11:15:00" },
  { id: "dl4", dealerId: "d1", dealerName: "Demo Bayi", action: "Satış", detail: "Samsung Galaxy S24 Ultra - IBAN 44.999 TL", ip: "192.168.1.100", date: "2026-07-14T13:00:00" },
  { id: "dl5", dealerId: "d1", dealerName: "Demo Bayi", action: "Satış", detail: "MacBook Air M3 - Cari 42.999 TL", ip: "192.168.1.100", date: "2026-07-14T14:45:00" },
  { id: "dl6", dealerId: "d2", dealerName: "İstanbul Şube", action: "Giriş", detail: "Sisteme giriş yapıldı", ip: "192.168.2.50", date: "2026-07-14T09:00:00" },
  { id: "dl7", dealerId: "d2", dealerName: "İstanbul Şube", action: "Ürün Ekleme", detail: "Yeni ürün eklendi: Lenovo ThinkPad X1", ip: "192.168.2.50", date: "2026-07-14T09:30:00" },
  { id: "dl8", dealerId: "d2", dealerName: "İstanbul Şube", action: "Satış", detail: "Lenovo ThinkPad X1 - Nakit 35.999 TL", ip: "192.168.2.50", date: "2026-07-14T10:00:00" },
  { id: "dl9", dealerId: "d3", dealerName: "Ankara Şube", action: "Giriş", detail: "Sisteme giriş yapıldı", ip: "192.168.3.75", date: "2026-07-14T08:45:00" },
  { id: "dl10", dealerId: "d3", dealerName: "Ankara Şube", action: "Rapor", detail: "Aylık satış raporu indirildi (Excel)", ip: "192.168.3.75", date: "2026-07-14T09:15:00" },
  { id: "dl11", dealerId: "d1", dealerName: "Demo Bayi", action: "Destek Talebi", detail: "Yeni destek talebi oluşturuldu: Ürün barkodu okunmuyor", ip: "192.168.1.100", date: "2026-07-14T09:30:00" },
  { id: "dl12", dealerId: "d5", dealerName: "Bursa Şube", action: "Giriş", detail: "Sisteme giriş yapıldı", ip: "192.168.5.20", date: "2026-07-14T10:00:00" },
  { id: "dl13", dealerId: "d1", dealerName: "Demo Bayi", action: "Cari İşlem", detail: "BilişimCenter A.Ş. cari hesabına 5.000 TL tahsilat", ip: "192.168.1.100", date: "2026-07-13T16:00:00" },
  { id: "dl14", dealerId: "d1", dealerName: "Demo Bayi", action: "Ürün Güncelleme", detail: "iPhone 15 fiyat güncellemesi: 47.999 → 48.999 TL", ip: "192.168.1.100", date: "2026-07-13T15:30:00" },
  { id: "dl15", dealerId: "d2", dealerName: "İstanbul Şube", action: "Çıkış", detail: "Sistemden çıkış yapıldı", ip: "192.168.2.50", date: "2026-07-13T18:00:00" },
];

// Backup history
export const mockBackups = [
  { id: "b1", fileName: "ART_POS_backup_2026-07-14_23-00.zip", size: "24.5 MB", date: "2026-07-14T23:00:00", type: "otomatik", status: "Başarılı" },
  { id: "b2", fileName: "ART_POS_backup_2026-07-13_23-00.zip", size: "23.8 MB", date: "2026-07-13T23:00:00", type: "otomatik", status: "Başarılı" },
  { id: "b3", fileName: "ART_POS_backup_2026-07-12_23-00.zip", size: "23.5 MB", date: "2026-07-12T23:00:00", type: "otomatik", status: "Başarılı" },
  { id: "b4", fileName: "ART_POS_backup_2026-07-10_manual.zip", size: "22.9 MB", date: "2026-07-10T15:30:00", type: "manuel", status: "Başarılı" },
  { id: "b5", fileName: "ART_POS_backup_2026-07-05_manual.zip", size: "21.2 MB", date: "2026-07-05T10:00:00", type: "manuel", status: "Başarılı" },
];

// Payment notifications for dealer
export const mockPaymentNotifications = [
  { id: "pn1", amount: 15000.00, ibanName: "Ziraat Bankası", ibanNumber: "TR12 0001 0012 3456 7890 1234 56", receiptUrl: "", status: "completed", note: "Temmuz ayı ilk hafta ödemesi", createdAt: "2026-07-10T14:30:00", updatedAt: "2026-07-10T16:45:00" },
  { id: "pn2", amount: 8500.00, ibanName: "Garanti BBVA", ibanNumber: "TR98 0006 2001 2345 6789 0123 45", receiptUrl: "", status: "completed", note: "", createdAt: "2026-07-08T11:00:00", updatedAt: "2026-07-08T14:20:00" },
  { id: "pn3", amount: 22000.00, ibanName: "İş Bankası", ibanNumber: "TR76 0004 6001 2345 6789 0123 45", receiptUrl: "", status: "pending", note: "Temmuz ayı ikinci hafta ödemesi", createdAt: "2026-07-14T09:15:00", updatedAt: "2026-07-14T09:15:00" },
  { id: "pn4", amount: 5000.00, ibanName: "Ziraat Bankası", ibanNumber: "TR12 0001 0012 3456 7890 1234 56", receiptUrl: "", status: "completed", note: "Bakiye kapatma", createdAt: "2026-07-05T16:00:00", updatedAt: "2026-07-05T17:30:00" },
  { id: "pn5", amount: 12000.00, ibanName: "Garanti BBVA", ibanNumber: "TR98 0006 2001 2345 6789 0123 45", receiptUrl: "", status: "rejected", note: "Hatalı dekont - yeniden gönderilecek", createdAt: "2026-07-12T10:45:00", updatedAt: "2026-07-12T13:00:00" },
];

// Invoices
export const mockInvoices = [
  { id: "inv1", invoiceNumber: "EAR2026001", type: "e-archive", customerName: "Ahmet Yılmaz", amount: 48999.00, date: "2026-07-14T10:35:00", status: "Onaylandı" },
  { id: "inv2", invoiceNumber: "EAR2026002", type: "e-archive", customerName: "Mehmet Demir", amount: 12998.00, date: "2026-07-14T11:20:00", status: "Onaylandı" },
  { id: "inv3", invoiceNumber: "EAR2026003", type: "e-archive", customerName: "TeknoMarket Ltd. Şti.", amount: 44999.00, date: "2026-07-14T13:05:00", status: "Beklemede" },
  { id: "inv4", invoiceNumber: "EFAT2026001", type: "e-fatura", customerName: "BilişimCenter A.Ş.", amount: 42999.00, date: "2026-07-14T14:50:00", status: "Gönderildi" },
  { id: "inv5", invoiceNumber: "EFAT2026002", type: "e-fatura", customerName: "DijitalDünya Ticaret", amount: 32999.00, date: "2026-07-12T11:00:00", status: "Onaylandı" },
  { id: "inv6", invoiceNumber: "EAR2026004", type: "e-archive", customerName: "Ayşe Korkmaz", amount: 15499.00, date: "2026-07-11T16:25:00", status: "İptal" },
];